import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTemplateComponent } from './document-template.component';
import { AddDocumentTemplateComponent } from './add-document-template/add-document-template.component';
import { CloneTemplateDialogComponent } from './clone-template-dialog/clone-template-dialog.component';
import { EditDocumentTemplateComponent } from './edit-document-template/edit-document-template.component';
import { DocumentTemplateSignaturesComponent } from './document-template-signatures/document-template-signatures.component';
import { DocumentTemplateRedactionsComponent } from './document-template-redactions/document-template-redactions.component';
import { SignatureFlowDialogComponent } from './signature-flow-dialog/signature-flow-dialog.component';
import { RedactionFlowDialogComponent } from './redaction-flow-dialog/redaction-flow-dialog.component';

import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RichEditorModule } from 'src/app/shared/components/rich-editor/rich-editor.module';

@NgModule({
    declarations: [
        DocumentTemplateComponent,
        AddDocumentTemplateComponent,
        CloneTemplateDialogComponent,
        EditDocumentTemplateComponent,
        DocumentTemplateSignaturesComponent,
        DocumentTemplateRedactionsComponent,
        SignatureFlowDialogComponent,
        RedactionFlowDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        RichEditorModule
    ],
    exports: [
        DocumentTemplateComponent,
        DocumentTemplateSignaturesComponent,
        DocumentTemplateRedactionsComponent
    ],
})
export class DocumentTemplateModule { }
